import { GPU } from "gpu.js";

export default new GPU({ mode: "gpu" });
